<template>
    <div class="wf-field">
        <label class="wf-label">
            {{ label }} <span v-if="isRequired" class="wf-required">*</span>
        </label>
        <p v-if="instruction" class="wf-instruction">{{ instruction }}</p>

        <!-- Parent categories -->
        <div v-if="!selectedParent" class="wf-category-grid">
            <button
                v-for="(cat, index) in categories"
                :key="index"
                type="button"
                class="wf-category-card"
                :class="{ 'is-selected': selectedLabel === cat.label && !hasChildren(cat) }"
                @click="onCategoryClick(cat)"
            >
                <i
                    :class="cat.icon || 'fal fa-folder'"
                    class="wf-category-icon"
                    :style="cat.color ? { color: cat.color } : null"
                ></i>
                <span class="wf-category-name">{{ cat.label }}</span>
                <i v-if="hasChildren(cat)" class="fal fa-chevron-right wf-category-arrow"></i>
            </button>
        </div>

        <!-- Subcategories -->
        <div v-else>
            <button type="button" class="wf-category-back" @click="goBack">
                <i class="fal fa-arrow-left"></i>
                {{ selectedParent.label }}
            </button>
            <div class="wf-category-grid">
                <button
                    v-for="(sub, index) in selectedParent.children"
                    :key="index"
                    type="button"
                    class="wf-category-card"
                    :class="{ 'is-selected': selectedSub === sub.label }"
                    @click="selectSubcategory(sub)"
                >
                    <i
                        :class="sub.icon || 'fal fa-folder'"
                        class="wf-category-icon"
                        :style="sub.color ? { color: sub.color } : null"
                    ></i>
                    <span class="wf-category-name">{{ sub.label }}</span>
                </button>
            </div>
        </div>

        <p v-if="help" class="wf-help">{{ help }}</p>
    </div>
</template>

<script>
import FieldMixin from './FieldMixin'

export default {
    name: 'CategoryField',
    mixins: [FieldMixin],
    data() {
        return {
            selectedParent: null
        }
    },
    computed: {
        categories() {
            if (!this.attribute.config || !this.attribute.config.options) return []
            return this.attribute.config.options[this.locale] || this.attribute.config.options['fr'] || []
        },
        selectedLabel() {
            if (!this.value) return null
            if (typeof this.value === 'object') return this.value.label
            return this.value
        },
        selectedSub() {
            if (!this.value) return null
            if (typeof this.value === 'object') return this.value.subcategory
            return null
        }
    },
    methods: {
        hasChildren(cat) {
            return cat.children && cat.children.length > 0
        },
        onCategoryClick(cat) {
            if (this.hasChildren(cat)) {
                this.selectedParent = cat
            } else {
                this.emitValue({ label: cat.label })
            }
        },
        selectSubcategory(sub) {
            this.emitValue({
                label: this.selectedParent.label,
                subcategory: sub.label
            })
        },
        goBack() {
            this.selectedParent = null
        }
    },
    created() {
        // If editing and value has a parent category with children, restore parent selection
        if (this.value && typeof this.value === 'object' && this.value.subcategory) {
            const parent = this.categories.find(c => c.label === this.value.label)
            if (parent && this.hasChildren(parent)) {
                this.selectedParent = parent
            }
        }
    }
}
</script>

<style scoped>
.wf-category-back {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px 14px;
    border: 1.5px solid #e2e8f0;
    border-radius: 9px;
    background: #fff;
    color: #475569;
    font-size: 0.82rem;
    font-weight: 600;
    cursor: pointer;
    margin-bottom: 12px;
    transition: all 0.2s;
}

.wf-category-back:hover {
    border-color: #0891B2;
    color: #0891B2;
    background: rgba(8, 145, 178, 0.04);
}

.wf-category-arrow {
    margin-left: auto;
    font-size: 0.7rem;
    color: #94a3b8;
}
</style>
